let activeAccessToken: string | undefined;

export function setActiveAccessToken(token: string | undefined) {
  activeAccessToken = token;
}

export function getActiveAccessToken() {
  return activeAccessToken;
}
